<template>
  <div class="row">
    <div class="col-12">
      <m-input
        class="search-form-field"
        v-model="search.COUPONNAME"
        nolabel
        :placeholder="$t('search.campaignname')"
      ></m-input>
      <m-input
        class="search-form-field"
        v-model="search.COUPONCODE"
        nolabel
        :placeholder="$t('search.campaigncode')"
      ></m-input>
    </div>
  </div>
</template>

<script>
import api from "../../api";
export default {
  data() {
    return {
      search: {
        COUPONNAME: null,
        COUPONCODE: null,
      },
    };
  },

  methods: {
    getSearch() {
      return this.search;
    },
    clearSearch() {
      this.search = {
        COUPONNAME: null,
        COUPONCODE: null,
      };
    },
  },
};
</script>

<style></style>
